import MobileOverlay from "@MobileOverlays/components/MobileOverlay";
import useGetOpenedAmenityGroup from "@MobileOverlays/features/amenityOverlay/hooks/useGetOpenedAmenityGroup";
import React from "react";
import MobileAmenityOverlayCountAmenities
    from "@MobileOverlays/features/amenityOverlay/components/MobileAmenityOverlayCountAmenities";
import useUpdateAmenitiesAndCloseSelection
    from "@CheckOrder/features/amenities/hooks/useUpdateAmenitiesAndCloseSelection";
import getPairedAmenityGroupType from "@CheckOrder/features/amenities/functions/getPairedAmenityGroupType";
import useCloseAmenityMobileOverlay from "@MobileOverlays/features/amenityOverlay/hooks/useCloseAmenityMobileOverlay";
import useLocalCountAmenityStates
    from "@CheckOrder/features/amenities/features/countAmenity/hooks/useLocalCountAmenityStates";

function MobileAmenityOverlay() {
    const pairedAmenityGroups = useGetOpenedAmenityGroup()
    const type = getPairedAmenityGroupType(pairedAmenityGroups)

    const {closeOverlay} = useCloseAmenityMobileOverlay()

    const {
        singleSelectedAmenities,
        setSingleSelectedAmenities,
        returnSelectedAmenities,
        setReturnSelectedAmenities,
    } = useLocalCountAmenityStates()

    const {
        closeAndUpdate,
        closeWithoutUpdating,
        response,
    } = useUpdateAmenitiesAndCloseSelection(
        closeOverlay,
        singleSelectedAmenities,
        returnSelectedAmenities,
        setSingleSelectedAmenities,
        setReturnSelectedAmenities
    )

    const amenityList = {
        [`${type === "count"}`]:
            <MobileAmenityOverlayCountAmenities
                pairedAmenityGroups={pairedAmenityGroups}
                closeAndUpdate={closeAndUpdate}
                closeWithoutUpdating={closeWithoutUpdating}
                singleSelectedAmenities={singleSelectedAmenities}
                returnSelectedAmenities={returnSelectedAmenities}
                setSingleSelectedAmenities={setSingleSelectedAmenities}
                setReturnSelectedAmenities={setReturnSelectedAmenities}
            />,
    }

    return (
        <MobileOverlay
            isActionSheet
            title="gegenlich"
            slideInDirection="up"
            wrapperClassName="ticket-amenities__mobile-overlay"
            backClick={closeWithoutUpdating}
        >
            {amenityList?.true}
        </MobileOverlay>
    )
}

export default MobileAmenityOverlay